import axiosInstance from "./api";
import axios from "axios";

export const resetPassword = async (
  token: string,
  newPassword: string,
  confirmPassword: string
) => {
  try {
    const response = await axiosInstance.post("/auth/reset-password", {
      token,
      newPassword,
      confirmPassword,
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw error.response.data;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const verifyAccount = async (token: string) => {
  try {
    const response = await axiosInstance.get(`/auth/verify?token=${token}`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw error.response.data;
    }
    throw new Error("An unexpected error occurred");
  }
};
